/** Browser time zones of Germany and France: analytics there needs statistics consent first. */
export const CONSENT_FIRST_TIME_ZONES: readonly string[] = ['Europe/Berlin', 'Europe/Busingen', 'Europe/Paris'];

/** Same-origin path Firebase Hosting rewrites to the `openPanelProxy` function. */
export const OPENPANEL_API_PATH = '/api/op';

/** OpenPanel's hosted API, where the proxy forwards events. */
export const OPENPANEL_API_URL = 'https://api.openpanel.dev';

/** Fired by EasyCookie on load for a returning visitor and each time the banner is saved. */
export const EASY_COOKIE_ACCEPTED_EVENT = 'easycookie::accepted';
